import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import NavBar from "@/components/NavBar";
import Hero from "@/components/Hero";
import Producer from "@/components/Producer";
import Products from "@/components/Products";
import Necessity from "@/components/Necessity";
import Carriers from "@/components/Carriers";
import Reviews from "@/components/Reviews";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import Admin from "@/pages/Admin";

const Landing = () => {
  return (
    <main
      data-testid="landing-page"
      className="min-h-screen bg-ivory text-ink font-sans"
    >
      <NavBar />
      <Hero />
      <Producer />
      <Products />
      <Necessity />
      <Carriers />
      <Contact />
      <Reviews />
      <Footer />
    </main>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/admin" element={<Admin />} />
        </Routes>
      </BrowserRouter>
      <Toaster theme="light" position="bottom-right" />
    </div>
  );
}

export default App;
